import { useSelector } from 'react-redux';
import { useSession } from 'next-auth/react';

const useCurrentUser = () => {
	// When a task is opened through a public URL, currentUser gets populated with the translator's data
	const currentUser = useSelector((state) => state.traEditor.currentUser);

	if (currentUser) {
		return {
			fullName: currentUser
				? `${currentUser?.name} ${currentUser?.last_name}`
				: '',
			id: currentUser?.id ?? 0,
			...currentUser,
		};
	}

	// In case a PM opens a task, user data comes from session
	const { data: session } = useSession();

	return {
		fullName: `${session?.user?.name ?? ''} ${session?.user?.lastName ?? ''}`,
		id: session?.user?.userID ?? 0,
		...session?.user,
	};
};

export default useCurrentUser;
